export default "__VITE_ASSET__CZHPdX_O__"